import React from "react";

import { FlatList, View, Dimensions } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import Skeletons from "../skeleton-components/Skeletons";

const { width: screenWidth } = Dimensions.get("window");

const LiveNowSliderSkeleton = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const ITEM_WIDTH =
    deviceSize === DEVICE_SIZES.XS
      ? screenWidth * 0.9
      : deviceSize === DEVICE_SIZES.SM
      ? 360
      : "auto";
  const isSmallDevice =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  const itemSpacing = screenWidth * 0.02;
  const fullItemWidth = ITEM_WIDTH + itemSpacing;

  // Create a static array for skeleton items (similar to HomeCardSkeleton’s approach)
  const skeletonItems = Array(3)
    .fill(0)
    .map((_, index) => ({ id: index }));

  const renderSkeletonItem = () => (
    <View style={[styles.item, { width: ITEM_WIDTH }]}>
      {/* Live badge and attendee count row */}
      <View
        style={{
          flexDirection: "row",
          gap: 10,
          alignItems: "center",
          alignSelf: "flex-start",
        }}
      >
        <Skeletons
          width={"50px"}
          height={isSmallDevice ? 20 : 26}
          style={{ borderRadius: 7 }}
        />
        <Skeletons
          width={" 20px"}
          height={isSmallDevice ? 14 : 26}
          style={{ borderRadius: 5 }}
        />
        <Skeletons width={"100px"} height={isSmallDevice ? 14 : 20} />
      </View>
      {/* Video players section */}
      <View
        style={{
          marginVertical: 16,
          flexDirection: "row",
          gap: 5,
          justifyContent: "center",
        }}
      >
        <Skeletons
          width={isSmallDevice ? "160px" : "265px"}
          height={isSmallDevice ? 105 : 173}
          style={{ borderRadius: 5 }}
        />
        <Skeletons
          width={isSmallDevice ? "160px" : "265px"}
          height={isSmallDevice ? 105 : 173}
          style={{ borderRadius: 5 }}
        />
      </View>
      {/* Title and participant section */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <View>
          {/* Title */}
          <Skeletons
            width={isSmallDevice ? "200px" : "240px"}
            height={isSmallDevice ? 16 : 28}
            style={{ marginBottom: 13, marginRight: 20 }}
          />
          {/* Game info */}
          <View
            style={{
              flexDirection: "row",
              gap: 13,
              alignItems: "center",
            }}
          >
            <Skeletons
              width={isSmallDevice ? "24px" : "40px"}
              height={isSmallDevice ? 24 : 40}
              circle
            />
            <Skeletons width={"100px"} height={isSmallDevice ? 10 : 14} />
          </View>
        </View>
        {/* Participants */}
        <View style={{ flexDirection: "row", gap: 20, alignItems: "flex-end" }}>
          <View style={{ alignItems: "center" }}>
            <Skeletons
              width={isSmallDevice ? "73px" : "100px"}
              height={isSmallDevice ? 72 : 95}
              style={{ borderRadius: 10 }}
            />
            <Skeletons
              width={"60px"}
              height={isSmallDevice ? 20 : 26}
              style={{ borderRadius: 7, marginTop: 5 }}
            />
          </View>
          <Skeletons width={"39px"} height={61} style={{ borderRadius: 5 }} />
          <View style={{ alignItems: "center" }}>
            <Skeletons
              width={isSmallDevice ? "73px" : "100px"}
              height={isSmallDevice ? 72 : 95}
              style={{ borderRadius: 10 }}
            />
            <Skeletons
              width={"60px"}
              height={isSmallDevice ? 20 : 26}
              style={{ borderRadius: 7, marginTop: 5 }}
            />
          </View>
        </View>
      </View>
    </View>
  );

  return (
    <View>
      {/* Heading and navigation placeholder */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 10,
          alignItems: "center",
          marginBottom: 20,
          paddingHorizontal: isSmallDevice ? "3.5%" : 0,
        }}
      >
        <Skeletons
          width={isSmallDevice ? "150px" : "200px"}
          height={isSmallDevice ? 16 : 24}
        />
        {!isSmallDevice && (
          <View style={{ flexDirection: "row", gap: 20 }}>
            <Skeletons circle width={"36px"} height={36} />
            <Skeletons circle width={"36px"} height={36} />
          </View>
        )}
      </View>
      {/* FlatList for skeleton items */}
      <FlatList
        horizontal
        data={skeletonItems}
        renderItem={renderSkeletonItem}
        keyExtractor={(item) => `skeleton-${item.id}`}
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{
          paddingHorizontal: isSmallDevice ? "3.5%" : 0,
          gap: 25,
        }}
        snapToInterval={isSmallDevice ? undefined : fullItemWidth}
        decelerationRate="fast"
      />
      {/* Separator */}
      <View
        style={{
          paddingHorizontal: isSmallDevice ? "3.5%" : 0,
        }}
      >
        <Skeletons
          height={2}
          width="100%"
          style={{
            marginTop: 20,
            // backgroundColor: AppColors.appGrayColor_1C1C1C,
          }}
        />
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    item: {
      width: 535,
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      item: {
        width: 535,
      },
    },
    [DEVICE_SIZES.SM]: {
      item: {
        width: 360,
      },
    },
    [DEVICE_SIZES.XS]: {
      item: {
        width: screenWidth * 0.9,
      },
    },
  }
);

export default LiveNowSliderSkeleton;
